export const GA_MEASUREMENT_ID = "G-6WSWNNCZ0Y";
